var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveGameIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.994 8.112l-2.665-1.87v-.479l2.665-1.87zm-9.06-4.225a.267.267 0 00-.267.267v3.699a.267.267 0 00.411.227l2.91-1.852a.267.267 0 000-.45l-2.91-1.85a.267.267 0 00-.143-.042zm5.073 6.118H2.002V2.002h8.005zM1.337.67a.667.667 0 00-.667.667v9.333c0 .368.298.667.667.667h9.333a.667.667 0 00.667-.667v-2.8l3.475 2.433a.333.333 0 00.525-.273V1.977a.333.333 0 00-.525-.274l-3.475 2.434v-2.8A.667.667 0 0010.67.67z"
  })));
}
export default __webpack_public_path__ + "static/svg/live-game-icon.svg";
export { SvgLiveGameIcon as ReactComponent };